import axiosInstance from '@/api/axios'

export interface PersonalInfoType {
    name?: string // 姓名
    gender?: string // 性别 1：男 2：女
    idType?: string // 证件类型
    idNo?: string // 证件号码
    birth?: string // 出生日期
    mobile?: string // 联系电话
    email?: string // 电子邮箱
    fixPhone?: string // 固定电话
    realAuth?: string // 是否实名认证 1:已实名 2:未实名
}

// 获取个人信息
export const getUserInfoApi = () => {
    return axiosInstance<PersonalInfoType>({
        url: '/auth/getUserInfo',
        method: 'get',
    })
}

// 修改个人信息
export const editUserInfoApi = (parameter: any) => {
    return axiosInstance<any>({
        url: '/auth/editUserInfo',
        method: 'post',
        data: parameter,
    })
}
